import type { NoticeMedia, NoticeMediaKind } from '@/types/notice'

/** Tipo da mídia de capa do aviso, usado nos ícones das listas (imagem ou vídeo). */
export function getNoticeMediaKind(
	media: NoticeMedia[],
): NoticeMediaKind | undefined {
	return media[0]?.kind
}
